/**
 * Limpio tags que vienen demas
 * @param text {string}
 * @example cleanTags(texto)
 */
export const cleanTags = (text: string) => {
  return text.replace(/(<([^>]+)>)/gi, '')
}
